import { lazy } from "react";
import { authRoles } from "app/auth/authRoles";
import CalculationList from "./CalculationList";
const calculationroutes = [
  {
    path: "/salary/calculation/list",
    element: <CalculationList />,
    auth: authRoles.admin, // Only admin can access this route
  }
];

export default calculationroutes;


// auth: [...authRoles.admin, ...authRoles.sales]